import FieldProto from "../../../fields3/proto/field-proto"
import {SortDirection} from "../../../data-structures/sort"
import {GroupByConfig} from "./@types"
import TaskFields from "../../../model2/task/task-fields"
import FieldsCollection from "../../../fields3/collection/base/fields-collection"
import {DateIntervalType} from "../../utils/datetime/interval"
import {ModelInterface} from "../../../data-structures/collection"
import {GROUP_DATE_TIME} from "../../const/fields/field2-groups"

// const debug = "GroupBy"
const debug = false

export default class GroupBy implements ModelInterface {

    public field?                   : FieldProto
    public sortDirection            : SortDirection
    params                          : {
        interval?   : DateIntervalType
    }

    public showFullIntervalLabel    : boolean = false // i.e. Weekly/Biweekly will show start and end of the interval
    public showAllOptions           : boolean = false // indicates whether to display all possible group values, even if no items belong to a group

    constructor(data: GroupByConfig, fields?: FieldsCollection) {
        debug && console.log(debug, 'constructor', data, fields)

        this.field          = data?.fieldId ? (fields?.get(data.fieldId) || gd.fields.get(data.fieldId)) : undefined
        this.sortDirection  = data?.sortDirection || SortDirection.ASC
        this.params         = data?.params || {}
    }

    static convertFromOldFormatToJSON(groupType: string) {
        const groupBy = new GroupBy({}, gd.fields.task)
        groupBy.field = gd.fields.task.getFieldByField1Id(groupType) || undefined
        return groupBy.toJSON()
    }

    get id(): ID {
        if (!this.field) {
            return "new-group-by"
        }

        return this.field.fieldId
    }

    get isValid(): boolean {
        return !!this.field && !!this.sortDirection
    }

    get isDate() {
        return this.field?.typeGroup === GROUP_DATE_TIME
    }

    getValue(value:any) {
        if (!this.field) return value

        return  this.field.groupValue(value, this)
    }

    getLabel(value:any) {
        if (!this.field) return value

        return  this.field.groupLabel(value, this)
    }

    getSortValue(value:any) {
        if (!this.field) return value

        return  this.field.groupSortValue(value, this)
    }

    toJSON() {
        return {
            fieldId         : this.field?.fieldId,
            sortDirection   : this.sortDirection,
            params          : this.params
        }
    }
}